export const CHECK = '/check/get';
export const CHECKS = '/check/list';
export const PROFILECHECKS = '/check/listProfile';
export const CHECKVERIFICATIONS = '/check/listVerify';
export const RUNCHECK = '/check/run';
export const RESOLVES = '/check/resolve';

export const PROFILE = '/profile/get';
export const PROFILES = '/profile/list';
export const PROFILEVERIFICATIONS = '/profile/listVerify';
export const VERIFYICS = '/profile/verifyic';
export const VERIFYMOBILES = '/profile/verifymobile';

export const USERLEADS = '/leads/listProfile';
export const LEADS = '/leads/list';

export const SUSPICIOUS = '/suspicious/list';
export const SUSPICIOUSVERIFY = '/suspicious/verify';

export const USERHISTORIES = '/history/listProfile';

export const REPORTEMAILS = '/email/result';

export const COUNTERS = '/counter';



// WEBPACK FOOTER //
// ./src/endpoints.js